<!--
 * @Author: tony.zhu
 * @Date: 2025-09-26 10:56:35
 * @LastEditTime: 2025-10-15 15:03:09
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div>
    <el-scrollbar class="scroll_bar">
      <WidgetMenu
        v-bind="$attrs"
        :data="widgetMenuFormDataModel"
        :isFixedMenu="true"
        v-on="$listeners"
      ></WidgetMenu>
    </el-scrollbar>
  </div>
</template>

<script>
import WidgetMenu from "./components/menu.vue";
export default {
  components: {
    WidgetMenu,
  },
  props: {
    widgetMenuFormDataModelProp: {
      type: Object,
      default() {
        return {
          children: [],
        };
      },
    },
  },
  data() {
    return {
      widgetMenuFormDataModel: {
        children: [],
      },
    };
  },
  methods: {
  },
  watch: {
    widgetMenuFormDataModelProp: {
      handler: function (n) {
        if (n && Object.keys(n).length) {
          for (const key in n) {
            if (Object.hasOwnProperty.call(n, key)) {
              const e = n[key];
              for (const t in this.widgetMenuFormDataModel) {
                if (
                  Object.hasOwnProperty.call(this.widgetMenuFormDataModel, t)
                ) {
                  if (t == key) {
                    this.widgetMenuFormDataModel[key] = e;
                  }
                }
              }
            }
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>